import {
  TestInputActivityModel,
  ActivityEntityModel
} from './../../../../../models/activities/test-input-activity';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import def from 'ajv/dist/vocabularies/discriminator';
import { TestInputActivity } from 'src/app/models/activities';
import { ValidationService } from 'src/app/services';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';

@Component({
    selector: 'wm-test-input-activity-input',
    templateUrl: './test-input-activity-input.component.html',
    styleUrl: './test-input-activity-input.component.css',
    standalone: false
})
export class TestInputActivityInputComponent extends ActivityView
  implements OnInit, OnDestroy {
  activity: TestInputActivity;

  ngOnDestroy(): void {
    if (
      this.activity &&
      this.activity.model &&
      (<TestInputActivityModel>this.activity.model).activityEntities
    ) {
      (<TestInputActivityModel>this.activity.model).activityEntities.forEach(
        ae => {
          this.form.removeControl(ae.activityId);
          this.form.removeControl(ae.activityId + '-skip');
        }
      );
    }
  }

  skipActivity(activityEntityM: ActivityEntityModel) {
    const ctl = this.form.controls[activityEntityM.activityId];

    if (activityEntityM.skipActivity) {
      ctl.disable();
    } else {
      ctl.enable();
    }
  }

  ngOnInit(): void {
    if (!this.form) {
      this.form = new UntypedFormGroup({});
    }

    // We create a form group for each Activity that has entities. Each entities validators get added to the form group for their activity
    // The activity Skip Form is seperate because the activity form group gets disabled if the skip is set to true.
    (<TestInputActivityModel>this.activity.model).activityEntities.forEach(
      ae => {
        const activityForm = new UntypedFormGroup({});
        const activitySkipForm = new UntypedFormGroup({});

        activitySkipForm.addControl(
          'skipActivity',
          new UntypedFormControl(null, (ae.hasEntities && ae.dataEntities.length == 0 && ae.canSkipActivity) ? Validators.required : Validators.nullValidator)
        );

        this.form.addControl(ae.activityId + '-skip', activitySkipForm);
        this.form.addControl(ae.activityId, activityForm);

        ae.dataEntities.forEach(de => {
          const deForm = ValidationService.createEntityValidationGroup(de);
          activityForm.addControl(de.templateCode, deForm);
        });
      }
    );
  }
}
